import React,{useState} from 'react';
import Image from 'next/image';
import campusdrivebg from "../../public/images/aboutsectionbg2.jpeg";
import DemoForm from '../homepageslider/demoform';
import Link from 'next/link';



const Aboutcontent = () => {

  const [demoForm, setDemoForm] = useState(false);
  const [addForm, setAddForm] = useState("");

  const handleDemoForm = () => {
    setAddForm("add");
    setDemoForm(true);
  };

  return (
    <>


       {demoForm && (
          <DemoForm
            isOpen={demoForm}
            onClose={() => setDemoForm(false)}
          />
        )}
      <div className='relative'>
        <Image src={campusdrivebg} alt='virtual interview' className='lg:h-[250px] h-[180px] w-full' />
        <div className='2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5 absolute inset-0 flex flex-col justify-center items-center'>
          <div className='grid grid-cols-1 lg:grid-cols-12'>
            <div className='col-span-1 lg:col-span-12 '>
              <p className='lg:text-4xl text-[13px] font-semibold text-[#fff]'>Stop Letting Your Stakeholder Find Your Competitos</p>
              <h2 className='lg:text-[60px] text-[16px] text-[#ff5349] font-[500]'> <span className=' text-white '>Lets Get Started : Call Us At</span> <Link href='tel:+91-9911868833' target="_blank" rel="noopener noreferrer" className="cursor-pointer">+91-9911868822</Link></h2>
            <Link href="#"><h2 className='lg:text-[50px] text-[16px] text-[#ff5349] font-semibold' onClick={() => handleDemoForm()}> <span   className='font-[500] text-white'>Or </span>Request For Call Back</h2></Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Aboutcontent